import type { ReactNode } from 'react';
import { cn } from '../utils';

export interface PageShellProps {
  children: ReactNode;
  className?: string;
  contentClassName?: string;
  centered?: boolean;
}

export const PageShell = ({
  children,
  className,
  contentClassName,
  centered = false
}: PageShellProps) => (
  <main
    className={cn(
      'min-h-screen text-foreground',
      centered ? 'flex items-center justify-center p-4' : '',
      className
    )}>
    <div className={cn(centered ? 'w-full' : 'w-full max-w-7xl', contentClassName)}>{children}</div>
  </main>
);
